<template>
  <CustomButton :to="{ name: 'customPropertiesList' }" label="Links.goBack" />
  <p class="page-title">Édition de propriété personnalisée</p>
  <div class="form-container">
    <FormKit
      type="form"
      @submit="submitHandler"
      :actions="false"
      incomplete-message="Désolé, tous les champs ne sont pas remplis correctement."
      :model="propertyData"
    >
      <FormKit
        type="text"
        name="name"
        label="Propriété"
        placeholder="Modifier le nom de la propriété"
        validation="required|length:1,50"
        :validation-messages="{
          required: 'Ce champ est obligatoire.',
          length: 'Ce champ doit contenir maximum 50 caractères.',
        }"
        v-model="propertyData.name"
      />

      <FormKit
        id="repeater"
        name="values"
        type="repeater"
        label="Valeurs de la propriété"
        #default="{ index }"
        :add-label="addNewValueLabel"
        min="1"
        v-model="propertyData.values"
      >
        <FormKit
          type="text"
          :label="`${index + 1}. Valeur`"
          name="value"
          validation="required|length:1,50|checkDuplicateName"
          :validation-rules="{checkDuplicateName}"
          placeholder="Modifier une valeur"
          :validation-messages="{
            required: 'Ce champ est obligatoire.',
            length: 'Ce champ doit contenir maximum 50 caractères.',
            checkDuplicateName:'Cette valeur existe déjà.'
          }"
        />
      </FormKit>
      <div class="test">
        <FormKit
          type="submit"
          label="Mettre à jour"
        />
      </div>
    </FormKit>
  </div>
</template>

<script setup lang="ts">
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import router from "@/router";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import CustomButton from "@/components/forms/CustomButton.vue";

const route = useRoute();
const propertyData = ref({
  uuid: "",
  name: "",
  values: [
    {value: ""}
  ],
});
const addNewValueLabel = "Ajouter une valeur";

function checkDuplicateName(node){
 return propertyData.value.values.filter((property)=>property.value.toLowerCase() === node.value.toLowerCase()).length === 1
}
onMounted(async () => {
  const propertyUuid = route.params.uuid;
  await fetchPropertyData(propertyUuid);
});

const fetchPropertyData = async (propertyUuid) => {
  try {
    const response = await ApiService.get("/properties/" + propertyUuid);

    propertyData.value.uuid = response.data.data.uuid;
    propertyData.value.name = response.data.data.name;
    propertyData.value.values = response.data.data.propertyValues.map((value) => ({
      uuid: value.uuid,
      value: value.value,
    }));
  } catch (error) {
  }
};

const submitHandler = (data, formNode) => {
  const propertyUuid = propertyData.value.uuid;
  data.uuid = propertyUuid;
  return ApiService.put(`/properties/${propertyUuid}`, data)
    .then(({ data }) => {
      swal.success("Propriété mise à jour !", "");
      router.push({ name: 'customPropertiesList' });
    })
    .catch(({response}) => {
      response.data.errors.forEach((error) => {
        let field = error.property;
        if (field) {
          field = field.replace('[', '.');
          field = field.replace(']', '');
          formNode.setErrors(
            null,
            {
              [field]: error.message
            }
          );
        }
        return false;
      });
      swal.error("Erreur lors de la modification de la propriété");
    });
};
</script>
<style scoped>
.test {
  display: flex;
  margin-top: 1.5rem;
  margin-right: 12px;
}
</style>